import { Clickable, Col, Icon, Row, Text } from 'components';
import { formatLocale, theme } from 'lib';
import mime from 'mime';
import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  border: 1px solid ${theme.GREY_20};
  border-radius: 12px;
  background: #fff;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: ${theme.GREY_40};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

const PostItem = ({ item, onClick, onDelete }) => {
  const { caption, media, createdAt } = item;
  const hasMedia = media && media.length > 0;

  function getMediaType() {
    if (item.processing) return 'Processing...';
    if (item.youtubeId) return 'YouTube video';
    if (!hasMedia && caption?.length) return 'Text';
    if (!hasMedia) return '';

    const firstMedia = media[0];
    const isVideo =
      mime.getType(firstMedia?.uri)?.includes('video') || firstMedia?.uri.includes('m3u8');

    return isVideo
      ? 'Video'
      : `${media.length > 1 ? `${media.length} i` : 'I'}mage${media.length > 1 ? 's' : ''}`;
  }

  return (
    <Card onClick={() => onClick && onClick(item)}>
      <Col noFlex wid="60%">
        <Row center gap="12px">
          {hasMedia && (
            <Col
              noFlex
              style={{
                width: 40,
                height: 40,
                borderRadius: 4,
                backgroundColor: theme.GREY_10,
                backgroundImage: `url(${media[0].uri})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {getMediaType() === 'Video' && <Icon type="play" dimensions={16} color="white" />}
            </Col>
          )}
          <Col>
            <Text b2 med numberOfLines={1}>
              {caption || getMediaType()}
            </Text>
            {!caption && (
              <Text c2 col={theme.GREY_60}>
                {getMediaType()}
              </Text>
            )}
          </Col>
        </Row>
      </Col>

      <Row noFlex gap="16px" center>
        <Col noFlex endAll>
          <Text c2 col={theme.GREY_60}>
            {createdAt ? formatLocale(new Date(createdAt), 'MMM dd, yyyy h:mm a') : ''}
          </Text>
        </Col>
        <Clickable
          onClick={(e) => {
            e.stopPropagation();
            onDelete && onDelete(item);
          }}
        >
          <FiTrash2 size={18} color={theme.SECONDARY} />
        </Clickable>
      </Row>
    </Card>
  );
};

export default PostItem;
